import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {Observable, catchError} from 'rxjs';
import {RatesTspExt} from '../../features/ratefile-tsp-ext/rates-tsp-ext';

@Injectable({
  providedIn: 'root'
})
export class RatefileTspExtService extends DataService {

  private baseURI = this.apiUri + '/ratefiletspext/';
  private _logger: LoggerService;

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  /*
  * Get all the Rate Periods records for a control type
  */

  getRateFilePeriod(controlType: string): Observable<any> {
    this.setUri(this.baseURI + controlType + '/controltype/');
    return this.http.get(this.baseURI + controlType + '/controltype/');
  }

  /*
  * Get Carrier List for a specific Business Type
  */

  getCarrierList(businessType: any): Observable<any> {
    this.setUri(this.baseURI + businessType + '/carrier/');
    return this.http.get(this.baseURI + businessType + '/carrier/');
  }

  /*
  * Get the TSP Rate Extension Record
  */

  getCarrierRateRec(controlId: number, carrierId: number): Observable<any> {
    this.setUri(this.baseURI + controlId + '/controlid/' + carrierId + '/carrierid/');
    return this.http.get(this.baseURI + controlId + '/controlid/' + carrierId + '/carrierid/');
  }

  /*
  *  Get the rate period record for a particular control id
  */

  getRatePeriodRec(controlId: number): Observable<any> {
    this.setUri(this.baseURI + controlId + '/controlid/');
    return this.http.get(this.baseURI + controlId + '/controlid/');
  }

  /*
  * Service method to call the create Rest Services
  */

  createRatesTspExt(rateFileTspExt: RatesTspExt): Observable<any> {
    return this.http.post(this.baseURI + 'savetspexpirydate/', rateFileTspExt).pipe(catchError(this.handleError));
  }

  getCurrentBidcycles(businessType: string): Observable<any> {
    return this.http.get(this.baseURI + businessType + '/currentBidcycles');
  }

  getCarriersListByBusinessType(businessType: string): Observable<any> {
    return this.http.get(this.baseURI + businessType + '/carrierslist');
  }

  getRatesTspExtByBusinessType(businessType: string): Observable<any> {
    return this.http.get(this.baseURI + businessType + '/businessType');
  }

  getCarriersListByParticipation(rateBidcycleId: number): Observable<any> {
    return this.http.get(this.baseURI + rateBidcycleId + '/frt/partcipatinglist');
  }

}
